export const footerContainer = "glass-panel px-6 py-4 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-text-muted mt-auto shrink-0";
export const copyrightText = "font-semibold text-text-secondary";
export const translationContainer = "flex gap-0.5 bg-bg-deep p-1 rounded-xl border border-border-color shrink-0";
export const getLangBtnClass = (isActive: boolean) => 
  `px-2.5 py-1 rounded-lg text-[10px] md:text-xs font-extrabold cursor-pointer transition-colors ${
    isActive ? 'bg-primary-accent text-bg-deep dark:text-black' : 'text-text-secondary hover:text-text-primary'
  }`;
